import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import CKEditor from '@ckeditor/ckeditor5-vue'
import '@fortawesome/fontawesome-free/js/all.min.js'

// Create Inertia App
createInertiaApp({
  resolve: name => {
    if (!name) {
      console.error('Component name is undefined or null');
      return;
    }
    try {
      console.log(`Resolving component: ${name}`);
      return require(`./Pages/${name}`).default;
    } catch (error) {
      console.error(`Error loading component: ${name}`, error);
      throw error;
    }
  },
  title: title => `${title} - Nowsauce CRM`,
  setup({ el, App, props, plugin }) {
    createApp({
      render: () => h(App, props)
    })
    .use(plugin)
    .use(CKEditor)
    .mount(el);
  },
});
